import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../lib/axios";
import { API_PORTAL_URL } from "../lib/config";
// import { SuccessToast } from "../components/common/Toast";

export const getAllActiveDining = createAsyncThunk(
  "Dining/FindAllActiveDining",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Dining/FindAllActiveDining`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Dining:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchAllActiveDining() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Dining/FindAllActiveDining`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}
